export default __webpack_public_path__ + "static/media/b1.342bc00d.svg";